import {Stack, Typography} from '@mui/material';
import {Link} from 'react-router-dom';

import {logo} from '../utils/Contants'
import SearchBar from './SearchBar';

const Navbar = () => {
  return (
    <Stack direction="row"
     alignItems="center"
      p={2}
     sx={{position: 'sticky', background: '#000', top: 0, justifyContent: 'space-between'}}>
      
<Link to ="/" style={{ display:'flex', alignItems: 'center'}}>

  <img src={logo} alt="logo"  height={30} /> 
  {/* <Typography sx={{ fontSize: '1rem' }}  variant='p' ml='2px'  color='white'>
  Youtube
  </Typography> */}
</Link>
<SearchBar/>

    </Stack>
  )
}

export default Navbar